module.exports = __webpack_public_path__ + "img/partners-pierce.5510ad0f.png";